<template>
  <div class="app_main">
    <router-view />
    <custom-customer  @closeCustomer="closeCustomer" v-if="closeCustom" />
  </div>
</template>
<script>
import { watch, ref } from 'vue'
import { useStore } from 'vuex'
import customCustomer from '../../components/customCustomer.vue'
export default {
  components: {
    customCustomer
  },
  setup () {
    const store = useStore()
    const closeCustom = ref(false)
    const closeCustomer = () => {
      store.state.isCustomCustomer = false
      closeCustom.value = false
    }
    watch(
      () => store.state.isCustomCustomer,
      (newVal) => {
        closeCustom.value = newVal
      }
    )

    return {
      closeCustomer,
      closeCustom
    }
  }
}
</script>
<style lang="scss" scoped>
.app_main {
  min-height: 800px;
  background: #f7f7f7;
  padding: 0 0 40px 0;
}
</style>
